import axios from 'axios';

const { post, get, patch, put } = axios;
const suppressErrorToast = { suppressErrorToast: true };

export default {
  login: data => post('/v1/login/', data),
  logout: () => post('/v1/logout/'),
  register: data => post('/v1/users/', data),
  forgotPassword: data => post('/v1/users/password_reset/', data),
  updatePassword: data => put('/v1/user/password/', data),
  getUserInfo: () => get('/v1/user/'),
  getExportUnits: () => get('/v1/user/export_units/'),
  updateExportUnits: data => patch('/v1/user/export_units/', data),
  setupMfa: data => post('/v1/user/mfa/setup/', data, suppressErrorToast),
  confirmMfa: data => post('/v1/user/mfa/confirm/', data, suppressErrorToast),
  disableMfa: data => post('/v1/user/mfa/disable/', data, suppressErrorToast),
  getSettings: () => get('/'),
};
